import { Image, Select } from 'antd'
import { useSelector } from 'react-redux'
import useTranslation from '@/hooks/useTranslation'

import InfoCircle from '../../svgs/InfoCircle'
import Arrow from '../../svgs/formBuild/ArrowDown.js'

const { Option } = Select

const SelectCountries = ({
  name,
  label,
  placeholder,
  value,
  setValue,
  error,
  searchable = true,
}) => {
  const { t } = useTranslation()
  const { countries } = useSelector((state) => state.countries)
  const validNames = countries.map((country) => country.name)
  return (
    <div>
      <label className='flex gap-8' htmlFor={name}>
        {t(label)}{' '}
        <InfoCircle style={!error ? 'opacity-0' : ''} color='#D93F21' />
      </label>
      <Select
        showSearch={searchable}
        id={name}
        placeholder={t(placeholder)}
        suffixIcon={<Arrow style='w-14' />}
        optionFilterProp={searchable ? 'children' : undefined}
        filterOption={
          searchable
            ? (input, option) =>
                option.children.props.children[1]
                  .toLowerCase()
                  .includes(input.toLowerCase())
            : undefined
        }
        value={value}
        onChange={(val) => {
          if (validNames.includes(val)) {
            setValue(val)
          }
        }}
      >
        {countries.map((country) => (
          <Option
            key={country.id}
            value={country.name}
            code={country.short_name}
          >
            <div className='flex items-center gap-8'>
              <Image
                width={24}
                height={16}
                alt={country.name}
                src={`https://purecatamphetamine.github.io/country-flag-icons/3x2/${country.short_name}.svg`}
              />
              {country.name}
            </div>
          </Option>
        ))}
      </Select>
    </div>
  )
}

export default SelectCountries
